import React from 'react';
import { useSelector } from 'react-redux';
import { getLiveFeed } from '../../store/getters/health-status';
import HealthStatusWithText from '../HealthStatus/HealthStatusWithText';
import { useIsMarketHours } from '../../hooks/useIsMarketHours';
import { isMobile } from '../../hooks/user-device';
import BrokerHealthStatusGadget from '../BrokerHealthStatusGadget';

const LiveFeed = () => {
  const status = useSelector(getLiveFeed);

  return (
    <>
      {status ? (
        <HealthStatusWithText status={status} baseLabel="Live Feed" />
      ) : (
        ''
      )}
    </>
  );
};

const HealthStatuses = () => {
  const isMarketHours = useIsMarketHours();

  if (!isMarketHours && isMobile) {
    return <div className="app-bar-health-status"></div>;
  }

  return (
    <div className="app-bar-health-status">
      <BrokerHealthStatusGadget />
      <LiveFeed />
    </div>
  );
};

export default HealthStatuses;
